import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { Offcanvas } from "bootstrap";
import { translations } from "../languages";
import { callAPI } from "../utils/apiUtils";
import { apiUrls } from "../utils/apiUrls";
import { ErrorMessage, SuccessMessage } from "../helpers/Index";
import { setCart, toggleCartRefresh } from "../store/cartSlice";
import { useDispatch } from "react-redux";
export default function ViewCart() {
  const [cartItems, setcartItems] = useState([]);
  const [Items, setItems] = useState({});
  const [loading, setLoading] = useState(false);
  const { language } = useLanguage();
  const getSessionId = () => {
    let sessionId = localStorage.getItem("session_id");
    if (!sessionId) {
      sessionId = "sess_" + Math.random().toString(36).substring(2, 15);
      localStorage.setItem("session_id", sessionId);
    }
    return sessionId;
  };

  const fetchUserCart = async () => {
    try {
      const session_id = getSessionId();
      setLoading(true);
      const apiResponse = await callAPI(apiUrls.cartview, {}, "POST", {
        session_id: session_id,
      });
      setLoading(false);
      if (apiResponse?.data?.success) {
        setcartItems(apiResponse?.data?.data?.items || []);
        setItems(apiResponse?.data?.data || {});
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    const offcanvasElement = document.getElementById("offcanvasExample");

    if (!offcanvasElement) return;

    const handleShown = () => {
      fetchUserCart();
    };

    offcanvasElement.addEventListener("shown.bs.offcanvas", handleShown);

    return () => {
      offcanvasElement.removeEventListener("shown.bs.offcanvas", handleShown);
    };
    // eslint-disable-next-line
  }, []);
  const dispatch = useDispatch();
  const removeItem = async (item, remove_all = false) => {
    try {
      const session_id = getSessionId();
      const apiResponse = await callAPI(apiUrls.cartremove, {}, "POST", {
        session_id: session_id,
        cart_item_id: item ? item?.id : null,
        remove_all: remove_all,
      });
      if (apiResponse?.data?.success) {
        SuccessMessage(apiResponse?.data?.message);
        fetchUserCart();
        dispatch(
          setCart({
            count: apiResponse?.data?.data?.total_items || 0, // whatever API returns
          }),
        );
        dispatch(toggleCartRefresh());
        localStorage.setItem(
          "cart_count",
          apiResponse?.data?.data?.total_items || 0,
        );
      } else {
        ErrorMessage(apiResponse?.data?.message);
      }
    } catch (error) {
      console.error(error);
    }
  };


    const updateQuantity = async (item, quantity) => {
      try {
        const session_id = getSessionId();
        const apiResponse = await callAPI(
          apiUrls.cartupdatequantity,
          {},
          "POST",
          {
            session_id: session_id,
            cart_item_id: item.id,
            quantity: quantity,
          },
        );
        if (apiResponse?.data?.success) {
          dispatch(
            setCart({
              count: apiResponse?.data?.data?.total_items || 0, // whatever API returns
            }),
          );
          localStorage.setItem(
            "cart_count",
            apiResponse?.data?.data?.total_items || 0,
          );
            dispatch(toggleCartRefresh());
          fetchUserCart();
         
        } else {
          ErrorMessage(apiResponse?.data?.message);
        }
      } catch (error) {
        console.error(error);
      }
    };

  const closeOffcanvas = () => {
    const offcanvasElement = document.getElementById("offcanvasExample");
    const bsOffcanvas = Offcanvas.getInstance(offcanvasElement);
    if (bsOffcanvas) {
      bsOffcanvas.hide();
    }
  };

  const t = translations[language];

  const isOrderClosed = (open_time, close_time) => {
    if (!open_time || !close_time) {
      return true;
    }

    // Japan current time
    const japanNow = new Date(
      new Date().toLocaleString("en-US", {
        timeZone: "Asia/Tokyo",
      }),
    );

    const [openHour, openMinute] = open_time.split(":").map(Number);

    const [closeHour, closeMinute] = close_time.split(":").map(Number);

    // Opening time
    const openingTime = new Date(japanNow);
    openingTime.setHours(openHour, openMinute, 0, 0);

    // Closing time
    const closingTime = new Date(japanNow);
    closingTime.setHours(closeHour, closeMinute, 0, 0);

    // Handle next-day closing
    // Example: 11 AM to 1 AM
    if (closingTime <= openingTime) {
      closingTime.setDate(closingTime.getDate() + 1);

      if (japanNow < openingTime) {
        japanNow.setDate(japanNow.getDate() + 1);
      }
    }

    // Last order 30 mins before closing
    const lastOrderTime = new Date(closingTime.getTime() - 30 * 60 * 1000);

    // Restaurant closed before opening
    if (japanNow < openingTime) {
      return true;
    }

    // Restaurant closed after last order time
    if (japanNow >= lastOrderTime) {
      return true;
    }

    return false;
  };
  const businessData = Items?.restaurant || Items?.food_truck;
  const orderClosed = isOrderClosed(
    businessData?.open_time,
    businessData?.close_time,
  );
  const businessName =
    language === "en" ? businessData?.en_name : businessData?.ja_name;
  return (
    <div
      className="offcanvas offcanvas-end cart-sidbar"
      tabIndex={-1}
      id="offcanvasExample"
      aria-labelledby="offcanvasExampleLabel"
    >
      <div className="offcanvas-header d-flex align-items-center justify-content-between border-bottom">
        <div
          className="offcanvas-title font--18 fw-medium"
          id="offcanvasExampleLabel"
        >
          {t.shoppingCart}
        </div>
        <button
          type="button"
          className="close-btn d-flex align-items-center gap-2"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        >
          {t.close} <img src="/image/times.svg" alt="" />
        </button>
      </div>

      <div className="offcanvas-body">
        {cartItems?.length > 0 && (
          <button
            type="button"
            className="blue-link font--14 fw-medium text-decoration-underline border-0 bg-transparent p-0"
            onClick={() => removeItem(null, true)}
          >
            {t.clearCart}
          </button>
        )}
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-danger" role="status">
              <span className="visually-hidden">{t.loading}</span>
            </div>
          </div>
        ) : cartItems.length === 0 ? (
          <div className="text-center py-5">
            <p>{t.yourCartIsEmpty}</p>
          </div>
        ) : (
          cartItems.map((item, index) => (
            <div
              className="cart-item  d-flex align-items-start gap-2 justify-content-between mb-4 mt-2"
              key={index}
            >
              <div className="cart-left d-flex align-items-center gap-lg-3 gap-2">
                <div className="sm-item">
                  <img
                    className="img-fluid"
                    alt={language === "en" ? item.en_menu_name : item.ja_menu_name}
                    src={
                      item?.image_urls && item.image_urls.length > 0
                        ? item.image_urls[0]
                        : "/image/default.png"
                    }
                  />
                </div>

                <div className="card-content">
                  <h3 className="mb-2 font--15 fw-medium">
                    {language === "en" ? item.en_menu_name : item.ja_menu_name}
                  </h3>
                  <div className="d-flex flex-wrap align-items-center gap-2">
                    {item?.addons?.map((addon, index) => (
                      <p className="mb-0" key={addon.id}>
                        {language === "en"
                          ? addon.en_addon_name
                          : addon.ja_addon_name}
                        <span className="link-text"> (¥{Math.round(Number(addon.price)).toLocaleString("ja-JP")})</span>

                        {index !== item.addons.length - 1 && ","}
                      </p>
                    ))}
                  </div>
                
                 <div className="d-flex align-items-center justify-content-between gap-2 mt-2">
                  <div className="d-flex align-items-center gap-2">
                     <p className="mb-0 qunt-item text-muted">
                      {" "}
                      {t.qty}:{" "}
                      <span className="text-dark">{item.quantity}</span>
                    </p>
                   <div className="qty-box d-flex align-items-center border rounded-2 overflow-hidden">
  <button
  type="button"
    className="btn btn-light border-0 px-2 py-1 fw-bold"
    disabled={item.quantity <= 1}
     aria-label="Decrease quantity"
    onClick={() => {
      const newQty = Math.max(1, item.quantity - 1);
      updateQuantity(item, newQty);
    }}
  >
    −
  </button>
  <span className="font--15 px-2 fw-medium">{item.quantity}</span>
  <button
   type="button"
    className="btn btn-light border-0 px-2 py-1 fw-bold"
    aria-label="Increase quantity"
    onClick={() => {
      const newQty = item.quantity + 1;
      updateQuantity(item, newQty);
    }}
  >
    +
  </button>
</div>
                              </div>
                    <h3 className="font--18 mt-2">
                      ¥
                     {Math.round(Number(item.total_price)).toLocaleString("ja-JP")}
                    </h3>
                  </div>
                </div>
              </div>
             <button
  type="button"
                className="cancel-card border-0 bg-transparent"
                onClick={() => removeItem(item)}
                 aria-label="Remove item"
              >
                <img src="/image/close.svg" alt="Remove item" />
              </button>
            </div>
          ))
        )}
      </div>

      {!loading && orderClosed && cartItems?.length > 0 && (
        <div className="order-closed-alertss">
          <div className="closed-iconss">
            <img src="/image/clock.svg" alt="" />
          </div>

          <div>
            <h4 className="closed-titless mb-1">{t.OnlineOrderingClosed}</h4>

            <p className="closed-textss mb-0">
              {t.onlineOrderingClosed} <strong>{businessName}</strong>.
              <br />
              {t.lastOrderMessage}
            </p>
          </div>
        </div>
      )}

      {cartItems.length > 0 && !orderClosed && (
        <div className="offcanvas-footer white-card-footer">
          <div className="d-flex align-items-center justify-content-between">
            <h5 className="mb-0 font--18 text-grey">{t.subtotal}</h5>
            <h3 className="mb-0 link-text">
              ¥
             {Math.round(Number(Items?.subtotal || 0)).toLocaleString("ja-JP")}
            </h3>
          </div>

          <div className="mt-3 d-flex align-items-center gap-3">
            <Link
              className="btn primary-btn flex-fill"
              to={"/view-cart"}
              onClick={closeOffcanvas}
            >
              <span className="me-2">
                <img src="/image/bag.svg" alt="" />
              </span>
              {t.viewCart}
            </Link>
            <Link
              className="btn secondary-btn flex-fill"
              to={"/checkout"}
              onClick={closeOffcanvas}
            >
              <span className="me-2">
                <img src="/image/category.svg" alt="" />
              </span>
              {t.checkout}
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}
